// extracted by mini-css-extract-plugin
export var LinkBtn = "LinkButton-module--LinkBtn--3Ly0w";